<template>
  <el-dialog :visible.sync="visible" width="760px" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="plannedOrder" :biz-id="form.plannedOrderId" perm="production:plannedOrder" :approve-status="String(form.approveStatus || '0')" :unapprove-disabled="form.convertStatus === '1'" @approve="approve(true)" @unapprove="approve(false)" />
            <el-button v-if="(isAuth('production:plannedOrder:update') || isAuth('production:plannedOrder:save')) && form.approveStatus !== '2' && form.convertStatus !== '1'" type="primary" size="small" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('production:plannedOrder:delete') && form.approveStatus !== '2' && form.convertStatus !== '1'" type="primary" size="small" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="计划单号"><el-input v-model="form.plannedOrderCode" :disabled="formDisabled || !!form.plannedOrderId" placeholder="留空自动编号" /></el-form-item>
      <el-form-item label="计划日期" prop="plannedDate"><el-date-picker v-model="form.plannedDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" :disabled="formDisabled" /></el-form-item>
      <el-form-item label="物料" prop="materialId">
        <el-input v-model="form.materialCode" readonly :disabled="formDisabled">
          <el-button v-if="!formDisabled" slot="append" @click="materialSelectorVisible = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="物料名称"><el-input v-model="form.materialName" disabled /></el-form-item>
      <el-form-item label="数量" prop="quantity"><el-input-number v-model="form.quantity" :min="0.000001" :precision="2" style="width:100%" :disabled="formDisabled" /></el-form-item>
      <el-form-item label="供给方式">
        <el-select v-model="form.supplyType" style="width:100%" :disabled="formDisabled">
          <el-option label="自制" value="make" /><el-option label="外购" value="buy" /><el-option label="委外" value="subcontract" />
        </el-select>
      </el-form-item>
      <el-form-item label="目标日期"><el-date-picker v-model="form.targetDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" disabled /></el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :disabled="formDisabled" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>
    </span>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

export default {
  name: 'PlannedOrderAddOrUpdate',
  components: { WorkflowDocButtons, MaterialSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      materialSelectorVisible: false,
      permCodes: [],
      form: {},
      rules: {
        plannedDate: [{ required: true, message: '计划日期不能为空', trigger: 'change' }],
        materialId: [{ required: true, message: '请选择物料', trigger: 'change' }],
        quantity: [{ required: true, message: '数量不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    formDisabled() {
      return this.readonly || String(this.form.approveStatus) === '2' || this.form.convertStatus === '1'
    },
    showViewToolbar() { return this.readonly && !!this.form.plannedOrderId },
    dialogTitle() {
      if (this.readonly) return '查看计划订单'
      return this.form.plannedOrderId ? '修改计划订单' : '新增计划订单'
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    onClosed() {
      this.readonly = false
      this.form = {}
    },
    init(row, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.form = row ? { ...row, quantity: Number(row.quantity || 1), targetDate: '' } : {
        plannedOrderCode: '', plannedDate: today(), materialId: '', materialCode: '', materialName: '', quantity: 1, supplyType: 'make', targetDate: '', remark: ''
      }
    },
    onMaterialSelect(m) {
      if (!m) return
      this.form.materialId = m.materialId
      this.form.materialCode = m.materialCode
      this.form.materialName = m.materialName
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.form.materialId) { this.$message.warning('请选择物料'); return }
        request.post('/plan/plannedOrder/save', {
          plannedOrderId: this.form.plannedOrderId, plannedOrderCode: this.form.plannedOrderCode, plannedDate: this.form.plannedDate,
          materialId: this.form.materialId, materialCode: this.form.materialCode, materialName: this.form.materialName,
          quantity: this.form.quantity, supplyType: this.form.supplyType, remark: this.form.remark
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      })
    },
    approve(yes) {
      const path = yes ? '/plan/plannedOrder/approve' : '/plan/plannedOrder/unapprove'
      request.post(path, { id: this.form.plannedOrderId }).then(() => {
        this.$message.success('操作成功')
        this.visible = false
        this.$emit('refreshDataList')
      }).catch(() => {})
    },
    remove() {
      this.$confirm('删除后，若该 MRP 批次下已无计划订单，批次会回到已运算，可再次生成。是否继续？', '提示', { type: 'warning' }).then(() => {
        request.post('/plan/plannedOrder/delete', { id: this.form.plannedOrderId }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
</style>
